module.exports = __webpack_public_path__ + "img/twitter.843dd8ca.png";